import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MdWarning } from 'react-icons/md';

import { supportReleaseRequest } from '~/store/modules/pickupValidation/actions';
import useRoles from '~/hooks/useRoles';
import { StatusMessage, Button, ModalFooter } from '../styles';

export default function StepSupportBlock({ cartId }) {
  const dispatch = useDispatch();
  const { isSupport } = useRoles();
  const { loadingSupportRelease } = useSelector(
    state => state.pickupValidation
  );

  const handleSupportRelease = useCallback(() => {
    dispatch(supportReleaseRequest(cartId));
  }, [dispatch, cartId]);

  return (
    <>
      <StatusMessage variant="warning">
        <MdWarning size={48} />
        <div className="title">Coleta bloqueada</div>
        <div className="subtitle">
          Os dados não conferiram após 3 tentativas. Por segurança, esta coleta
          foi bloqueada e o código do parceiro não será liberado.
          <br />
          <br />
          <strong>
            Não entregue a mercadoria. Acione o suporte Viddy para que a
            identidade do entregador seja verificada.
          </strong>
          <br />
          <br />
          <span style={{ fontSize: 12 }}>
            Após a liberação pelo suporte, feche e abra novamente esta janela
            para atualizar o status.
          </span>
        </div>
      </StatusMessage>

      {isSupport && (
        <ModalFooter style={{ padding: '16px 0 0', border: 0 }}>
          <Button
            type="button"
            variant="danger"
            onClick={handleSupportRelease}
            disabled={loadingSupportRelease}
          >
            {loadingSupportRelease
              ? 'Liberando...'
              : 'Liberar coleta (suporte)'}
          </Button>
        </ModalFooter>
      )}
    </>
  );
}
